"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedTextArrayResolver = void 0;
/**
 * The `LocalizedTextArrayResolver` resolves the correct text array of the given language.
 */
class LocalizedTextArrayResolver {
    constructor(locale, defaultLocales, unresolvedLabel) {
        this.locale = locale;
        this.defaultLocales = defaultLocales;
        this.unresolvedLabel = unresolvedLabel;
    }
    resolve(textArray) {
        if (textArray == null)
            return undefined;
        // build locales array ordered by priority:
        //  1. required locale
        //  2. default locales as given in order
        //  3. the first object property (which is probably alpha-sorted or any random value)
        const locales = [this.locale].concat(this.defaultLocales).concat(Object.keys(textArray)[0]);
        const l = locales.length;
        let i = 0;
        for (; i < l; i++) {
            if (textArray[locales[i]])
                return textArray[locales[i]];
        }
        return [this.unresolvedLabel];
    }
}
exports.LocalizedTextArrayResolver = LocalizedTextArrayResolver;
//# sourceMappingURL=LocalizedTextArrayResolver.js.map